import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=d94b17fe&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=ts&"
export * from "./tongji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94b17fe",
  null
  
)

export default component.exports